import React, {useCallback, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import {IconButton, TextField} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import MenuItem from "@mui/material/MenuItem";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import {formValidations} from "../CVTemplate";
import DeleteIcon from "@mui/icons-material/Delete";

const Qualification = [
    {
        value: "",
        label: "Select qualification",
    },
    {
        value: "Certificate",
        label: "Certificate",
    },
    {
        value: "Diploma",
        label: "Diploma",
    },
    {
        value: "Bachelors",
        label: "Bachelors",
    },
    {
        value: "Honours",
        label: "Honours",
    },
    {
        value: "Masters",
        label: "Masters",
    },
    {
        value: "PHD",
        label: "PHD",
    },
    {
        value: "Other",
        label: "Other",
    },
];

export default function Education({education, updateCV, userHasClickedNext, readOnly}) {
    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    };

    const [formData, setFormData] = useState(education);
    const [loopCounter, setLoopCounter] = useState(1);
    const [key, setKey] = useState(0);

    const handleChange = async (e, index) => {
        let {name, value} = e.target;
        setFormData((prevFormData) => {
            const newFormData = [...prevFormData];
            newFormData[index] = {
                ...newFormData[index],
                [name]: value,
            };
            updateCV('education', newFormData);
            return newFormData;
        });
    };

    const checkReqData = useCallback(() => {
        for (let i = 0; i < formData.length; i++) {
            if (Object.values(formData[i]).includes("")) {
                formValidations[2].valid = false;
                return;
            }
        }
        formValidations[2].valid = true;
    }, [formData]);

    useEffect(() => {
        setLoopCounter(formData.length || 1);
        checkReqData();
    }, [formData, checkReqData]);

    const addEducation = () => {
        setLoopCounter(loopCounter + 1);
        setFormData((prevFormData) => [
            ...prevFormData,
            {
                institution: "",
                qualification: "",
                qualificationType: "",
                startDate: "",
                dateAttained: ""
            },
        ]);
    }

    const deleteEducation = (index) => {
        setFormData((prevFormData) => {
            const newFormData = [...prevFormData];
            newFormData.splice(index, 1); // Remove the last item
            setKey((prevKey) => prevKey + 1);
            updateCV('education', newFormData);
            setLoopCounter((prevCounter) => prevCounter - 1);
            return newFormData;
        });
    };


    return (
        <Grid container direction="row" spacing={2} padding={2}>
            {Array.from(Array(loopCounter)).map((c, index) => {
                const currentFormData = formData[index];
                return (
                    <Grid container direction="row" spacing={2} padding={2} justifyContent="flex-start"
                          alignContent="center">
                        {loopCounter > 1 && index >= 1 ? (
                            <Grid container direction="row" spacing={2} padding={2} justifyContent="flex-start"
                                  alignContent="center">
                                <Grid item xs={7.5}>
                                    <h3 data-testid="HeadingEducation">Education {index}:</h3>
                                </Grid>

                                <Grid item xs={1}>
                                    {loopCounter > 1 ? (
                                        <IconButton hidden={readOnly} onClick={() => {
                                            deleteEducation(index)
                                        }} style={{
                                            color: '#FF6600',
                                        }}><DeleteIcon/></IconButton>
                                    ) : (
                                        <IconButton hidden={readOnly} disabled={true} style={{
                                            color: '#808080',
                                        }}><DeleteIcon/></IconButton>
                                    )}

                                </Grid>
                            </Grid>
                        ) : (
                            <Grid container direction="row" spacing={2} padding={2} justifyContent="flex-start"
                                  alignContent="center">
                                <Grid item xs={7.5}>
                                    <h3 data-testid="HeadingEducation">Education:</h3>
                                </Grid>
                                <Grid item xs={1}>
                                    {loopCounter > 1 ? (
                                        <IconButton hidden={readOnly} onClick={() => {
                                            deleteEducation(index)
                                        }} style={{
                                            color: '#FF6600',
                                        }}><DeleteIcon/></IconButton>
                                    ) : (
                                        <IconButton hidden={readOnly} disabled={true} style={{
                                            color: '#808080',
                                        }}><DeleteIcon/></IconButton>
                                    )}

                                </Grid>
                            </Grid>
                        )}

                        <Grid item xs={8}>
                            <TextField label="Institution"
                                       sx={style}
                                       value={currentFormData.institution}
                                       onChange={e => handleChange(e, index)}
                                       required
                                       variant={readOnly ? "standard" : "outlined"}
                                       error={userHasClickedNext && !currentFormData.institution}
                                       name="institution"
                                       data-testid="institution"
                                       style={{width: "100%"}}>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>
                        <Grid item xs={8}>
                            <TextField label="Qualification"
                                       sx={style}
                                       select
                                       name="qualification"
                                       required
                                       variant={readOnly ? "standard" : "outlined"}
                                       error={userHasClickedNext && !currentFormData.qualification}
                                       value={currentFormData.qualification}
                                       style={{width: "100%"}}
                                       onChange={e => handleChange(e, index)}>
                                {Qualification.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>

                        </Grid>
                        <Grid item xs={4}>

                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                sx={style}
                                style={{width: "100%"}}
                                name="qualificationType"
                                required
                                variant={readOnly ? "standard" : "outlined"}
                                error={userHasClickedNext && !currentFormData.qualificationType}
                                label="Qualification Name"
                                data-testid="qualificationType"
                                value={currentFormData.qualificationType}
                                onChange={e => handleChange(e, index)}>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>
                        <Grid item xs={8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker label="Start Date"
                                            openTo="year"
                                            sx={style}
                                            key={key}
                                            format="YYYY"
                                            views={['year']}
                                    // minDate={dayjs(currentFormData.startDate)}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    required: true,
                                                    variant: readOnly ? "standard" : "outlined",
                                                    error: userHasClickedNext && !currentFormData.startDate,
                                                    inputProps: {"data-testid": "educationStartDate"}
                                                }
                                            }}
                                            style={{width: "100%"}}
                                            onChange={(newValue) => handleChange({
                                                target: {
                                                    name: "startDate",
                                                    value: newValue
                                                }
                                            }, index)}
                                            defaultValue={dayjs(currentFormData.startDate)}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>
                        <Grid item xs={8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker label="Date attained"
                                            openTo="year"
                                            sx={style}
                                            key={key}
                                            format="YYYY"
                                            views={['year']}
                                    // maxDate={dayjs(currentFormData.dateAttained)}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    required: true,
                                                    variant: readOnly ? "standard" : "outlined",
                                                    error: userHasClickedNext && !currentFormData.dateAttained,
                                                    inputProps: {"data-testid": "educationEndDate"}
                                                }
                                            }}
                                            style={{width: "100%"}}
                                            onChange={(newValue) => handleChange({
                                                target: {
                                                    name: "dateAttained",
                                                    value: newValue
                                                }
                                            }, index)}
                                            defaultValue={dayjs(currentFormData.dateAttained)}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>
                    </Grid>)
            })}
            <Grid container direction="row" padding={2} spacing={2} display="flex" justifyContent="flex-start"
                  alignItems="flex-end">
                <Grid item xs={1.5}>
                    <Button onClick={addEducation} variant="outlined" hidden={readOnly} style={{
                        width: '89px',
                        height: '40px',
                        fontFamily: 'Poppins',
                        color: '#FF6600',
                        borderColor: '#FF6600'
                    }}>Add</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}